import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';

const OrdersItem = (props) => {
    return (
        props.items.map((post2)=>{
                return (
                    <li key={post2.ID}>
                        <div className="item">
                            <div className="in">
                                <div className="item-name font-size-12 text-dgrey font-weg-300"> {post2.PROD} ( per {post2.VOLUME}{post2.UOM}) </div>
                                <div className="font-size-12 font-weg-400">
                                    <span className="text-danger">&#8377; {post2.RATE2}</span> x {post2.QTY}
                                </div>
                                <span className="badge badge-light font-size-14 font-weg-400">&#8377; {post2.TOTAL}</span>
                            </div>
                        </div>
                    </li>
                )                
        })
    );
}

const OrdersItemList = (props) => {
    return (
        props.orders.map((post,i)=>{
            return (<OrdersItem key={i} items={post.ITEMS_DET} />);
        })
    );
}

const Discounts = (props) => {
    return (
        props.discount.map((post2,i) => {
            return(
                <ul className="item-total listview image-listview" key={i}>
                    <li>
                        <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                            <div className="in">
                                <div className="item-name text-warning">{post2.NAME}</div>
                                {post2.DISCOUNT=='0' && <span className="badge badge-light font-size-14 font-weg-400 text-warning">{post2.TEXT}</span>}
                                {post2.DISCOUNT!='0' && <span className="badge badge-light font-size-14 font-weg-400 text-warning">-&#8377; {post2.DISCOUNT}</span>}
                            </div>
                        </div>
                    </li>
                </ul>
            );
        })
    );    
}

const CessCharges = (props) => {
    return (
        props.cessItems.map((post2,i) => {
            return(
                <ul className="item-total listview image-listview" key={i}>
                    <li>
                        <div className="item font-size-13 font-weg-300">
                            <div className="in">
                                <div className="item-name"> CESS </div>
                                <div className="item-qty"> {post2.PERC}% </div>
                                <span className="badge badge-light font-size-13 font-weg-300">&#8377; {post2.VALUE}</span>
                            </div>
                        </div>
                    </li> 
                </ul>
            );
        })
    );    
}

const TaxCharges = (props) => {
    return (
        props.taxItems.map((post2,i) => {
            return(
                <ul className="item-total listview image-listview" key={i}>
                    <li>
                        <div className="item font-size-13 font-weg-300">
                            <div className="in">
                                <div className="item-name"> SGST </div>
                                <div className="item-qty"> {post2.PERC}% </div>
                                <span className="badge badge-light font-size-13 font-weg-300">&#8377; {post2.SGST}</span>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="item font-size-13 font-weg-300">
                            <div className="in">
                                <div className="item-name"> CGST </div>
                                <div className="item-qty"> {post2.PERC}% </div>
                                <span className="badge badge-light font-size-13 font-weg-300">&#8377; {post2.CGST}</span>
                            </div>
                        </div>
                    </li>
                </ul>
            );
        })
    );    
}

const OrdersTotalBreakUp = (props) => {
    return (
        props.orders.map((post,i)=>{
            return (
                <div key={i}>
                    <ul className="item-total listview image-listview">
                        <li>
                            <div className="item font-size-14 font-weg-400">
                                <div className="in">
                                    <div className="item-name"> Subtotal </div>
                                    <span className="badge badge-light font-size-14 font-weg-400">&#8377; {post.SUB_TOTAL}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <TaxCharges taxItems={props.tax} />
                    <CessCharges cessItems={props.cess} />
                    {/*post.DISCOUNT!='0.00' && <ul className="item-total listview image-listview">
                        <li>
                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                <div className="in">
                                    <div className="item-name text-warning"> Coupon Discount </div>
                                    <span className="badge badge-light font-size-14 font-weg-400 text-warning">-&#8377; {post.DISCOUNT}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                    */}
                    {/*post.DISCOUNTTEXT!='' && <ul className="item-total listview image-listview">
                        <li>
                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                <div className="in">
                                    <div className="item-name text-warning"> Free {post.DISCOUNTTEXT} </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    */}
                    {post.DISCOUNTS_APPLIED.length>0 && <Discounts discount={post.DISCOUNTS_APPLIED} />}
                    <ul className="item-total listview image-listview">
                        <li>
                            <div className="item pt-06 pb-06 font-size-14 font-weg-400">
                                <div className="in">
                                    <div className="item-name"> Delivery Charges </div>
                                    {post.DELIVERY_CHARGES=='' && <span className="badge badge-light font-size-14 font-weg-400">Free</span>}
                                    {post.DELIVERY_CHARGES!='' && <span className="badge badge-light font-size-14 font-weg-400">&#8377; {post.DELIVERY_CHARGES}</span>}
                                </div>
                            </div>
                        </li>
                    </ul>
                        {post.DELIVERY_GST!='' &&
                            <ul className="item-total listview image-listview">
                                <li>
                                    <div className="item font-size-13 font-weg-300">
                                        <div className="in">
                                            <div className="item-name"> SGST </div>
                                            <div className="item-qty"> {post.DELIVERY_GST}% </div>
                                            <span className="badge badge-light font-size-13 font-weg-300">&#8377; {post.DELIVERY_SGST}</span>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <div className="item font-size-13 font-weg-300">
                                        <div className="in">
                                            <div className="item-name"> CGST </div>
                                            <div className="item-qty"> {post.DELIVERY_GST}% </div>
                                            <span className="badge badge-light font-size-13 font-weg-300">&#8377; {post.DELIVERY_CGST}</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        } 
                    <ul className="item-total listview image-listview">  
                        <li>
                            <div className="section-title w-100 font-size-14 d-flex justify-content-between pt-2 pb-2 pr-0 pl-0 medium"> Total
                                <span className="font-weg-600">&#8377; {post.TOTAL}</span>
                            </div>
                        </li>
                    </ul>
                </div>
            );
        })
    )
}

const OrderAddress = (props) => {
    return (
        props.orders.map((post,i)=>{
            return (
                <div className="wide-block loc-details" key={i}>
                    <p align="left" className="labbbel">{post.LABEL}</p>
                    <p align="left">{post.ADDRESS}</p>
                    {post.ADDRESS2 && <p align="left">{post.ADDRESS2}</p>}
                    {post.ADDRESS3 && <p align="left">{post.ADDRESS3}</p>}
                </div>
            );
        })
    )
}

/*<button key={i} type="button" className={`btn btn-${post.STATUS_CSS} btn-block`}>{post.STATUS}</button>*/

const OrderStatus = (props) => {
    return (
        props.orders.map((post,i)=>{
            return (
                <span key={i} className={`badge badge-${post.STATUS_CSS}`}>{post.STATUS}</span>
            );
        })
    )
}

const OrderInstructions = (props) => {
    return (
        props.orders.map((post,i)=>{
            return (
                <div className="row" style={{width: '100%'}} key={i}>
                    {post.INSTRUCTIONS!='' &&
                        <div className="col-12">
                            <div className="div-instruction">
                                <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                                &nbsp; Special Instructions: <br />
                                <p key={i} className="p-instruction">
                                {post.INSTRUCTIONS}
                                </p>
                            </div>
                        </div>    
                    }
                </div>
            );
        })
    )
}

const OrderCancellationReason = (props) => {
    return (
        props.orders.map((post,i)=>{
            return (
                <div className="row" style={{width: '100%'}} key={i}>
                    {post.CANCELLEDREASON!='' &&
                        <div className="col-12">
                            <div className="div-instruction">
                                <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                                &nbsp; Reason For Cancellation: <br />
                                <p key={i} className="p-instruction">
                                {post.CANCELLEDREASON}
                                </p>
                            </div>
                        </div>    
                    }
                </div>
            );
        })
    )
}

class CustomerOrdersDetails extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOADING: true, 
            id: props.match.params.id,
            CustomerOrders: [],
            CustomerTax: [],
            CustomerCess: [],
            Notifications: '',
            SUCCESS: ''
        };
    }

    fetchCustomerOrders(mode,customer,order_id) {
        var that = this;
        fetch('https://m.donedelivery.in/api/customerordersdet_api.php?mode='+mode+'&customer='+customer+'&id='+order_id,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let customer_orders = result.orders;
            if(customer_orders=='' || customer_orders==undefined)
                customer_orders = '';

            that.setState({ LOADING:false, CustomerOrders:customer_orders, CustomerTax:result.tax, CustomerCess:result.cess});
        });
    }

    handleSubmitComplaint = (e) => {
        e.preventDefault();

        var complaint_text = $('#txtcomplaint').val().trim();
        if(complaint_text!=='')
        {
            let id = this.state.id;
            let customer = localStorage.getItem('userData');

            var that = this;
            fetch('https://m.donedelivery.in/api/customerordercomplaint_api.php?mode=COMPLAINT&id='+id+'&customer='+customer+'&txtcomplaint='+complaint_text,{
                mode: 'cors',
                credentials: 'same-origin',
                headers: {
                    'Access-Control-Allow-Origin': '*', 
                    Accept: 'application/json', 
                    'Content-Type': 'application/json',
                },
            }).then(function (response) {
                return response.json();
            }).then(function (result) {

                $('#DialogIconedInfo').modal('hide');

                let notify = 'Complaint Registered Successfully';
                let SUCCESS = 'Y';
                if(result.err!='' && result.err!=undefined && result.err!='undefined')
                {
                    if(result.err=='1') notify = 'Invalid Details Detected';
                    else if(result.err=='2') notify = 'ERR';
                    else if(result.err=='3') notify = 'ERR';
                    else if(result.err=='4') notify = 'Invalid Access Detected';

                    SUCCESS = 'N';
                }

                that.setState({ Notifications: notify, SUCCESS: SUCCESS});
                if(notify!='')
                    $('#ModalAlert').modal('show');
            });
        }
        else
            alert('The field cannot be empty');
    }

    handleReOrderCart = () => {
        $('#reorderCart').modal('show');
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        this.fetchCustomerOrders('ORDERS',customer,this.state.id);
    }

    render() { 

        //localStorage.removeItem("userData");
        //localStorage.removeItem("cartData");
        //localStorage.removeItem("delCity");
        //localStorage.removeItem("delArea");
        //console.log(localStorage.getItem('userData'));

        let logged = 'N';
        if(localStorage.getItem('userData'))
            logged = 'Y';

        if (logged=='N')
        {
            if(localStorage.getItem('cartData'))
                return (<Redirect to={'/cart'}/>)
            else
                return (<Redirect to={'/home'}/>)
        }
        
        let Verified = '';
        if(localStorage.getItem('Verified') !== null && localStorage.getItem('Verified')!=='{}')
        {
            if(localStorage.getItem('userData'))
                Verified = localStorage.getItem('Verified');
        }
        else
            Verified = 'N';

        if(Verified=='N')
        {
            return (<Redirect to={'/verifyMobile'}/>);
        }
        
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/orders';
        let AppHeaderTitle = 'Order Details';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="section full mt-2 pb-4">
                        <div className="section inset pt-0 pb-1">
                            <div className="row">
                                <div className="col-12">
                                    {this.state.CustomerOrders.length>0 && this.state.CustomerOrders.map((post,i)=>{
                                        return (
                                            <div className="card p-2" key={i}>
                                                <div className="content-header p-0 font-size-13 text-dgrey font-weg-500">Delivery Address:</div>
                                                <div className="section-title w-100  d-flex justify-content-between pt-0 pb-0 pr-0 pl-0">
                                                    <p className="mb-0 pt-05 w-70 text-mgrey font-size-12">{post.ADDRESS}</p>
                                                    <span>
                                                        <span className={`btn text-upper newshadowed font-size-9 square btn-${post.STATUS_CSS}2 btn-sm btn-block`}>{post.STATUS}</span>
                                                        <p className="font-size-12 pt-1 text-center">{post.DATE2}</p>
                                                    </span>
                                                </div>
                                            </div>
                                        );
                                    })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="cart-list-items">
                            <ul className="item-title listview image-listview">
                                <li>
                                    <div className="item font-size-14 font-weg-400">
                                        <div className="in">
                                            <div className="item-name"> Item </div>
                                            <div className="item-qty"> Qty </div>
                                            <span className="badge badge-light font-size-14 font-weg-400">Price</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <ul className="listview image-listview">
                                { this.state.CustomerOrders.length>0 && <OrdersItemList orders={this.state.CustomerOrders} /> }
                            </ul>
                            
                            {this.state.CustomerOrders.length>0 && <OrdersTotalBreakUp orders={this.state.CustomerOrders} tax={this.state.CustomerTax} cess={this.state.CustomerCess}/>}
                            
                        </div>
                        { this.state.CustomerOrders.length>0 && this.state.CustomerOrders.map((post,i)=>{
                            if(post.STATUS2==='D')
                            {
                                return (
                                    <div className="pt-0 pr-2 pl-2 pb-4" key={i}>
                                        <div className="col-12 p-0">
                                            <div className="anik-jai accordion" id="accordionExample1">
                                                <div className="item">
                                                    <div className="accordion-header">
                                                        <button className="btn text-danger collapsed mb-05" type="button" data-toggle="collapse" data-target="#accordion1" aria-expanded="false"> REGISTER YOUR COMPLAINT? </button>
                                                    </div>
                                                    <div id="accordion1" className="accordion-body collapse" data-parent="#accordionExample1">
                                                        <div className="accordion-content">
                                                            <textarea rows="3" className="square-inputbox form-control square" name="txtcomplaint" id="txtcomplaint" placeholder="Type Here"></textarea>
                                                        </div>
                                                        <div className="text-upper">
                                                            <div className="row">
                                                                <div className="col-4"> </div>
                                                                <div className="col-4"> 
                                                                    <button type="button" style={{'height': '31px'}} className="btn newshadowed text-dgrey font-size-11 square btn-outline-secondary btn-llg btn-block goBack" onClick={(event) => this.handleSubmitComplaint(event)}>Submit</button>
                                                                </div>
                                                                <div className="col-4"> </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                        </div>
                                        <div className="modal fade dialogbox" id="ModalAlert" data-backdrop="static" tabIndex="-1" role="dialog">
                                            <div className="modal-dialog" role="document">
                                                <div className="modal-content">
                                                    {this.state.SUCCESS=='N' && <div className="modal-icon text-danger"><ion-icon name="close-circle"></ion-icon></div>}
                                                    {this.state.SUCCESS=='Y' && <div className="modal-icon text-success"><ion-icon name="checkmark-outline"></ion-icon></div>}
                                                    <div className="modal-body"> 
                                                        {this.state.Notifications} 
                                                    </div>
                                                    <div className="modal-footer">
                                                        <div className="btn-inline"> 
                                                            <button type="button" className="btn" data-dismiss="modal">Close</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })
                        }
                        { this.state.CustomerOrders.length>0 && this.state.CustomerOrders.map((post,i)=>{
                            if(post.STATUS2!=='D')
                            {
                                return (
                                    <div className="form-button-group1 pr-2 pl-2" key={i}>
                                        <div className="col-12">
                                            <div className="text-upper">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <Link to={`/ordertrack/${post.ID}`} className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block">Track Order</Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }

                            if(post.STATUS2==='D')
                            {
                                return (
                                    <div key={i}>
                                        <div className="form-button-group1 pr-2 pl-2">
                                            <div className="col-12">
                                                <div className="text-upper">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <button type="button" onClick={()=>{this.handleReOrderCart()}} className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block">Re-Order</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal fade dialogbox" id="reorderCart" data-backdrop="static" tabIndex="-1" role="dialog">
                                            <div className="modal-dialog" role="document">
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">&nbsp;</h5>
                                                    </div>
                                                    <div className="modal-body"> 
                                                        Items Out of Stock will not be added to the cart. Continue? 
                                                    </div>
                                                    <div className="modal-footer">
                                                        <div className="btn-inline"> 
                                                            <Link to={`/reorder/${post.ID}`} className="btn btn-text-success">Yes</Link>
                                                            <button type="button" className="btn btn-text-danger" data-dismiss="modal">No</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        })
                        }
                    </div>
                </div>
            </div>
        );
    }
}
  
export default CustomerOrdersDetails;


// WEBPACK FOOTER //
// ./src/components/CustomerOrdersDetails.js